import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthLocalService } from "@core/auth/auth-local.service";
import { environment } from "environments/environment";
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class CalculadoraVidrioService {
    private newtoken: string;
    constructor(
        private _authLocal: AuthLocalService,
        private http: HttpClient,
    ) { }
    calcular(payload: any): Observable<any> {
        return this.http.post(environment.api.calculadora_vidrios.calcular, payload)
    }
    getCalculo(data: any): Observable<any> {
        return this.http.post<any>(environment.api.calculadora_vidrios.calcular, data);
    }
    getCamaras(filtro = ''): Observable<any> {
        var subject = new Subject<any>();
        this.http.get<any>(environment.api.calculadora_vidrios.get_camaras + filtro)
        .subscribe((resp: any) => {
            this.newtoken = resp.token;
            this._authLocal.updateToken(this.newtoken);
            subject.next(resp.result); 
            subject.complete(); 
        }, (error) => {
            subject.error(error);
        });
        return subject.asObservable();
    }
    getCategoriaVidrios(filtro = ''): Observable<any> {
        var subject = new Subject<any>();
        this.http.get<any>(environment.api.calculadora_vidrios.get_categoria_vidrios + filtro)
        .subscribe((resp: any) => {
            this.newtoken = resp.token;
            this._authLocal.updateToken(this.newtoken);
            subject.next(resp.result); 
            subject.complete(); 
        }, (error) => {
            subject.error(error);
        });
        return subject.asObservable();
    }
}
